declare const toastr: any;

export function flashNotice(message: string, title: string = '') {
  toastr.info(message, title, {
  showDuration: "300",
    hideDuration: "1000",
    timeOut: "5000",
    extendedTimeOut: "1000",
    progressBar: true,
    allowHtml: true,
    positionClass: "toast-top-center"})
}

export function flashError(message: string, title: string = '') {
  toastr.error(message, title, {
    closeButton: true,
    allowHtml: true,
    showDuration: "300",
    hideDuration: "1000",
    timeOut: "0",
    extendedTimeOut: "0",
    progressBar: true,
    positionClass: "toast-top-center"})
}